module.exports = __webpack_public_path__ + "static/media/home.9c7cef0f.svg";